import script from "./HeaderView.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderView.vue?vue&type=script&setup=true&lang=js"

import "./HeaderView.vue?vue&type=style&index=0&id=24ac53c8&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24ac53c8"]])

export default __exports__